import React, { useState } from 'react'

const AminFormsNav = ({setScreen}) => {

    const [activeButton, setActiveButton] = useState()

    const handleButtonPress = (screen) => {
        setScreen(screen);
        setActiveButton(screen);
      }

  return (
    <nav className='flex flex-row w-full h-10 bg-gray-300'>
        <div className={`h-full w-1/2 flex items-center justify-center text-white ${activeButton === "AdminDDJJ" ? "bg-gray-400" : ""}`}>
           <button className='text-white' onClick={()=>handleButtonPress('AdminDDJJ')}>DDJJ</button>
        </div>
        <div className={`h-full w-1/2 flex items-center justify-center text-white ${activeButton === "AdminANEXO" ? "bg-gray-400" : ""}`}>
           <button className='text-white' onClick={()=>handleButtonPress('AdminANEXO')}>CONSENTIMIENTO</button>
        </div>


        <div className={`h-full w-1/2 flex items-center justify-center text-white ${activeButton === "ANEXORENOVADO" ? "bg-gray-400" : ""}`}>
           <button className='text-white' onClick={()=>handleButtonPress('ANEXORENOVADO')}>Consentimiento Renovado</button>
        </div>

        <div className={`h-full w-1/2 flex items-center justify-center text-white ${activeButton === "DDJJRENOVADO" ? "bg-gray-400" : ""}`}>
           <button className='text-white' onClick={()=>handleButtonPress('DDJJRENOVADO')}>DDJJ Renovado</button>
        </div>
    </nav>
  )
}

export default AminFormsNav